// Class: starling.filters.CompositeLayer

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;

// Constructor

var CompositeLayer = function() {
	this.x = this.y = 0;
	this.alpha = 1.0;
	this.color = 16777215;
}

// Meta

CompositeLayer.__name__ = ["starling","filters","CompositeLayer"];
CompositeLayer.prototype = {
	
};
CompositeLayer.prototype.__class__ = CompositeLayer.prototype.constructor = $hxClasses["starling.filters.CompositeLayer"] = CompositeLayer;

// Init



// Statics




// Export

exports.default = CompositeLayer;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/filters/CompositeLayer.js
// module id = 321
// module chunks = 0